
class RegisterResponseData {
  constructor({ returnVal = 0, userId = 0 } = {}) {
    this.returnVal = returnVal;
    this.userId = userId;
  }

  static fromJson(json) {
    return new RegisterResponseData({
      returnVal: json.return,     // backend field "return"
      userId: json.user_Id        // backend field "user_Id"
    });
  }
}
export default RegisterResponseData;